// extracted by mini-css-extract-plugin
export var buttons = "N_cr";
export var column = "N_dc";
export var columns = "N_db";
export var container = "N_b";
export var down = "N_df";
export var download = "N_dd";
export var footer = "N_cb";
export var information = "N_c9";
export var section = "N_d";
export var show = "N_L";
export var text = "N_b0";
export var title = "N_h";
export var units = "N_dg";
export var up = "N_dj";
export var upload = "N_dh";
export var waveOne = "N_q";
export var waveThree = "N_bZ";
export var waveTwo = "N_n";
export var waves = "N_bY";